var map = {
	".": 86,
	"./": 86,
	"./App": 85,
	"./App.js": 85,
	"./App.scss": 276,
	"./App.test": 277,
	"./App.test.js": 277,
	"./images/banner.png": 842,
	"./images/dashen_logo.png": 843,
	"./images/game1.png": 844,
	"./images/game2.png": 845,
	"./images/game3.png": 846,
	"./images/game4.png": 847,
	"./images/game5.png": 848,
	"./images/game6.png": 849,
	"./images/game7.png": 850,
	"./images/game8.png": 851,
	"./images/gamel_ogo.png": 852,
	"./images/header.png": 853,
	"./images/icon-more.png": 854,
	"./images/netease.1.png": 855,
	"./images/netease.2.png": 316,
	"./images/nie.2.png": 317,
	"./images/popogame_logo.png": 856,
	"./index": 86,
	"./index.css": 275,
	"./index.js": 86,
	"./logo.svg": 857,
	"./serviceWorker": 318,
	"./serviceWorker.js": 318,
	"./setupTests": 319,
	"./setupTests.js": 319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 590;